/* eslint-disable react-hooks/exhaustive-deps */
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { CircularProgress, Typography } from "@mui/material";
import { loginRequest } from "auth/microsoft";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import DetailLayout from "layouts/DetailLayout";
import MainLayout from "layouts/MainLayout";
import { isEmpty } from "lodash";
import PAGE from "pages";
import { useEffect, useMemo, useState } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { IdentityActions, SignalRAction } from "redux/actions";
import { useAppDispatch, useAppSelector } from "redux/configurations/reduxHooks";
import PrivateRoute from "./PrivateRoute";
import { DETAIL_ROUTES, MENU_ITEMS, convertMenuItems } from "./menu";
import { matchPath } from "react-router-dom";
import QueryString from "qs";
import _ from "lodash";

export type RouterProps = {
  isAuthenticated: boolean;
};

const MainRouter = () => {
  return (
    <MainLayout>
      <Switch>
        {convertMenuItems(MENU_ITEMS).map((route) => {
          return <PrivateRoute key={`main-router-${route.path}`} isMicrosoftAuthenticated exact component={route.component} path={route.path} />;
        })}
      </Switch>
    </MainLayout>
  );
};

const DetailRouter = () => {
  const location = useLocation();
  const maxWidth = useMemo(() => {
    const route = DETAIL_ROUTES.find((e) => {
      return matchPath(location.pathname, e.path!);
    });
    return route?.maxWidth;
  }, [location.pathname]);

  return (
    <DetailLayout maxWidth={maxWidth}>
      <Switch>
        {convertMenuItems(DETAIL_ROUTES).map((route) => {
          return <PrivateRoute exact isMicrosoftAuthenticated key={`detail-router-${route.path}`} component={route.component} path={route.path} />;
        })}
      </Switch>
    </DetailLayout>
  );
};

function AppRouter() {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const { instance: signalR } = useAppSelector((state) => state.SignalRReducer);

  const authenticate = useAppSelector((state) => state.IdentityReducer.authenticate);
  const microsoftAuthenticate = useAppSelector((state) => state.IdentityReducer.microsoftAzureAuthenticate);
  const deviceId = useAppSelector((state) => state.IdentityReducer.deviceId);
  const { inProgress, instance } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);
  const isMicrosoftAuthenticated = !_.isEmpty(authenticate);
  const location = useLocation()

  // const handelAcquireTokenSilent = async () => {
  //   const myAccount = instance.getAccountByUsername(microsoftAuthenticate?.account?.username || "") || undefined;
  //   setLoading(true);
  //   // console.log("isMicrosoftAuthenticated", isMicrosoftAuthenticated);
  //   // console.log(!isEmpty(authenticate?.jwToken));
  //   // console.log(!isEmpty(microsoftAuthenticate?.accessToken));
  //   // console.log(myAccount);

  //   if (!isEmpty(authenticate?.jwToken) && !isEmpty(microsoftAuthenticate?.accessToken) && myAccount) {
  //     instance
  //       .acquireTokenSilent({
  //         scopes: loginRequest.scopes,
  //         account: myAccount,
  //       })
  //       .then((res) => {
  //         if (res.accessToken) {
  //           dispatch(IdentityActions.microsoftAzureAuthenticate.request(res));
  //           // dispatch(
  //           //   IdentityActions.pingAuthenticate.request({
  //           //     accessToken: res.accessToken,
  //           //     deviceId,
  //           //   })
  //           // ); //chua sua
  //         }
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //         // console.log("Error", err);
  //         if (err instanceof InteractionRequiredAuthError) {
  //           instance
  //             .loginRedirect({
  //               ...loginRequest,
  //             })
  //             .catch(() => {
  //               AlertHelper.showAlert("Đăng nhập thất bại, vui lòng liên hệ admin để được hỗ trợ!", EAlertType.ERROR);
  //               console.log("loginRedirect", "Failed");
  //             });
  //         } else {
  //           AlertHelper.showAlert("Đăng nhập thất bại, vui lòng liên hệ admin để được hỗ trợ!", EAlertType.ERROR);
  //           dispatch(IdentityActions.logout.request());
  //         }
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   } else {
  //     setLoading(false);
  //     dispatch(IdentityActions.logout.request());
  //   }
  // };

  useEffect(() => {
    if (inProgress === InteractionStatus.None && isMicrosoftAuthenticated) {
      if (window.location.pathname.includes("login")) {
        history.replace("/authenticator");
      } else {
        // handelAcquireTokenSilent();
      }
    }
  }, [inProgress, isMicrosoftAuthenticated]);

  useEffect(() => {
    if (!isEmpty(authenticate?.jwToken) && !isEmpty(microsoftAuthenticate?.accessToken)) {
      dispatch(SignalRAction.initInstance.request(authenticate?.jwToken!));
    }
  }, [authenticate, microsoftAuthenticate]);

  useEffect(() => {
    if (signalR) {
      signalR?.onNotificationHub();
      signalR?.runService();
    }
    return () => {
      signalR?.remove();
    };
  }, [signalR]);

  if (loading) {
    return (
      <div
        style={{
          flex: 1,
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <CircularProgress
          color={"primary"}
          style={{
            marginBottom: 20,
          }}
        />
        <Typography>Đang đăng nhập</Typography>
      </div>
    );
  }

  return (
    <Switch>
      <Redirect exact from="/" to={`/master-data/product-configuration${location.search || ''}`} />;
      <Redirect exact from="/authenticator" to="/master-data/product-configuration" />;
      <Route path={"/login"} component={PAGE.Login} />
      <Route path={"/logout"} component={PAGE.Logout} />
      <Route path={"/authenticator"} component={PAGE.Authenticator} />
      <PrivateRoute isMicrosoftAuthenticated={isMicrosoftAuthenticated} exact path={convertMenuItems(MENU_ITEMS).map((route) => route.path!)} component={MainRouter} />
      <PrivateRoute isMicrosoftAuthenticated={isMicrosoftAuthenticated} exact path={convertMenuItems(DETAIL_ROUTES).map((route) => route.path!)} component={DetailRouter} />
      <Route component={PAGE.NotFound} />
    </Switch>
  );
}

export default AppRouter;
